import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { FirmWareUpdatingDataActions, FirmWareUpdatingDataActionTypes } from '../actions/firm-ware-updating-data.actions';
import {FirmWareLog} from '../firm-ware.model';

export interface State extends EntityState<FirmWareLog> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<FirmWareLog> = createEntityAdapter<FirmWareLog>({
  selectId: firmWareLog => firmWareLog.Id
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(state = initialState, action: FirmWareUpdatingDataActions): State {
  switch (action.type) {
    case FirmWareUpdatingDataActionTypes.GetFirmWareUpdatingDatas:
      adapter.removeAll(state);
      return {...state, Loaded: false, Loading: true};

    case FirmWareUpdatingDataActionTypes.GetDelayFirmWareUpdatingDatas:
      adapter.removeAll(state);
      return {...state, Loaded: true, Loading: false};

    case FirmWareUpdatingDataActionTypes.LoadFirmWareUpdatingDatas:
      return adapter.setAll(action.payload, {
        ...state,
        Loaded: true,
        Loading: false
      });

    case FirmWareUpdatingDataActionTypes.UpsertFirmWareUpdatingDatas:
      return adapter.upsertMany(action.payload, {
        ...state,
        Loaded: true,
        Loading: false
      });

    case FirmWareUpdatingDataActionTypes.ClearFirmWareUpdatingDatas:
      return adapter.removeAll(state);

    default:
      return state;
  }
}
